import { TopNavigation } from "./navigation/TopNavigation";

export const Navigation = () => {
  return <TopNavigation />;
};
